import { buildMatchPath } from "pages/PageConfigs";
import { CenterFlexColumn } from "styles/layout";
import { SwissMatchCell } from "./styles";
import { Match, getWinningRosterIds } from "model/Match/Match";
import { PlainNavLink } from "styles/elements";

interface Props {
  match: Match;
  rosterId: string;
}

export const SimpleSwissTableMatchResult = ({ match, rosterId }: Props) => {
  const winningRosterIds = getWinningRosterIds(match);
  const isWinningRoster = winningRosterIds?.includes(rosterId) ?? false;

  return (
    <SwissMatchCell winningTeam={isWinningRoster}>
      <PlainNavLink to={buildMatchPath(match.id)}>
        <CenterFlexColumn style={{ fontSize: "16pt" }}>
          {isWinningRoster ? "W" : "L"}
        </CenterFlexColumn>
      </PlainNavLink>
    </SwissMatchCell>
  );
};
